import { Input } from '@/components/ui/input';
import { Filter, Search } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { TipStatus } from '@/types/tips';


interface TipsSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  filter: 'all' | TipStatus;
  onFilterChange: (value: 'all' | TipStatus) => void;
}

export function TipsSearch({
  searchQuery,
  onSearchChange,
  filter,
  onFilterChange,
}: TipsSearchProps) {
  return (
    <div className='flex gap-4 mb-4'>
      <div className='relative flex-1'>
        <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground' />
        <Input
          placeholder='Search tips...'
          value={searchQuery}
          onChange={e => onSearchChange(e.target.value)}
          className='pl-10'
        />
      </div>
      <Select
        value={filter}
        onValueChange={(value: 'all' | TipStatus) => onFilterChange(value)}
      >
        <SelectTrigger className='w-48'>
          <Filter className='h-4 w-4 mr-2' />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='all'>All Tips</SelectItem>
          <SelectItem value='pending'>Pending</SelectItem>
          <SelectItem value='approved'>Approved</SelectItem>
          <SelectItem value='rejected'>Rejected</SelectItem>
          <SelectItem value='in_progress'>In Progress</SelectItem>
          <SelectItem value='completed'>Completed</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
